import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const StayPromoCodes = () => {
  return (
    <>
      <Box className="headingBtnWrap">
        <Typography variant="h1">Promo Codes</Typography>
      </Box>
    </>
  )
}

export default StayPromoCodes
